module.exports = __webpack_public_path__ + "img/2.c4c248a3.png";